/* Common */

export class CommonUtils {
    public capitalizeFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    public formatDate(date: Date): string {
        return date.toLocaleDateString();
    }
}